import { render, staticRenderFns } from "./NormalSearchNav148.vue?vue&type=template&id=5c63c44f&scoped=true"
import script from "./NormalSearchNav148.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav148.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c63c44f",
  null
  
)

export default component.exports